import { render, staticRenderFns } from "./bid-popover.vue?vue&type=template&id=1ab63973&scoped=true"
import script from "./bid-popover.vue?vue&type=script&lang=js"
export * from "./bid-popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab63973",
  null
  
)

export default component.exports